import {
  useFunctionMutation,
  useFunctions,
} from '@/core/domain/enterprise/Functions/Functions.hooks';
import { EmployeeFunction } from '@/core/domain/enterprise/Functions/Functions.types';
import { useDebounce } from '@/hooks';
import useSelectOptions from '@/hooks/useSelectOptions';
import { Select, SelectProps, Typography } from 'antd';
import { useEffect, useState } from 'react';

interface Props extends SelectProps {
  onCallback?: (employeeFunction: EmployeeFunction) => void;
}

const FunctionsSelect: React.FC<Props> = (props) => {
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);
  const [selectClicked, setSelectClicked] = useState<boolean>(false);

  const employeeFunction = useFunctions(
    {
      rows: 30,
      content: search,
      displayDefaultFunctions: true,
    },
    selectClicked,
  );

  const detail = useFunctionMutation();

  const options = useSelectOptions({
    directList: employeeFunction,
    detail: detail,
    selectProps: props,
    labelFormatter: (employeeFunction) => (
      <>
        <div key={employeeFunction.id}>
          <Typography.Text>{employeeFunction.name}</Typography.Text>
        </div>

        {employeeFunction?.code && (
          <div>
            <Typography.Text
              type="secondary"
              strong={!!employeeFunction.matrixId}
            >
              {employeeFunction.code}
            </Typography.Text>
          </div>
        )}
      </>
    ),
  });

  useEffect(() => {
    if (
      detail.data?.id &&
      detail.data.id === props.value &&
      !!props.onCallback
    ) {
      props.onCallback(detail.data);
    }
  }, [detail.data, props.value]);

  return (
    <Select
      {...props}
      loading={employeeFunction.isFetching}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      allowClear
      options={options}
      onSelect={(functionId: number) => {
        setSelectClicked(false);

        const selectedFunction = employeeFunction.data?.find(
          (employeeFunction) => employeeFunction.id === functionId,
        );

        if (!!selectedFunction && !!props.onCallback) {
          props.onCallback(selectedFunction);
        }
      }}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
    />
  );
};

export default FunctionsSelect;
